module.exports = __webpack_public_path__ + "static/bnr_square@3x-03c85b595de6581def4f51ce99d27f00.png";